import { Injectable } from "@angular/core";
import { HttpService } from "src/app/utils/http-service.service";

@Injectable({
  providedIn: 'root'
})

export class EnderecoService {
  
  constructor(private service: HttpService) { }

  buscaEndereco(cep: any) {
    return this.service.sendGet(`admin/endereco/${cep}`);
  }
}
